import styled from 'styled-components';

const StyledProgressLine = styled.line`
  animation: ${(props) => props.kf} 2s linear forwards;`;

export default StyledProgressLine;
